let apiUrl = '';
let middlewareUrl = '';

apiUrl = 'https://tilaukset.verman.fi/api';
middlewareUrl = 'https://tilaukset.verman.fi/nav-middleware/';


export const API_URL_MIDDLEWARE = middlewareUrl;
export const API_URL = apiUrl;

export const PRODUCT_STORE = 'ProductStore';
export const CART_STORE = 'CartStore';
export const CUSTOMER_STORE = 'CustomerStore';
export const ORDER_FORM_STORE = 'OrderFormStore';
export const NOTIFICATION_STORE = 'NotificationStore';
export const AUTH_STORE = 'AuthStore';
export const ORDER_TYPES_STORE = 'OrderTypesStore';
export const COMPANY_STORE = 'CompanyStore';
export const FEEDBACK_STORE = 'FeedbackStore';
export const MODAL_STORE = 'ModalStore';
export const ORDER_HISTORY_STORE = 'OrderHistoryStore';
export const FILTER_STORE = 'FilterStore';

export const DATE_FORMAT = 'YYYY-MM-DD';

// tslint:disable-next-line:max-line-length
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const VERMAN_BRANDS = ['Sorbact', 'Smartlax', 'Rela', 'Lactrase', 'Ramavit',
  'Minisun', 'Wonderm', 'Bethover', 'Helein', 'Synomax', 'Melarest'];

export const BIOTEEKKI_BRANDS = ['Super', 'Teho', 'Probiootti', 'Dentiplus', 'Elinvoima', 'KP',
  'Omega', 'Unia'];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/constants.ts